// ===== TIPOS DE RESPUESTA DEL WEBVIEW (Compatible con Asistente) =====
export enum WebviewResponseType {
  Successfull = 'successfull',
  Cancelated = 'cancelated',
  Omitted = 'omitted',
  Error = 'error'
}

// ===== RESPUESTA DEL WEBVIEW DE REGISTRO FACIAL =====
export interface WebViewPersonResponse {
  temporaryPersonId: string;
}

export interface WebViewResponse {
  message: string;
  type: WebviewResponseType;
  data?: WebViewPersonResponse;
}

// ===== EVENTOS DEL WEBVIEW DE REGISTRO FACIAL (Para uso interno) =====
export enum FaceRegistrationEventType {
  FACE_REGISTRATION_SUCCESS = 'FACE_REGISTRATION_SUCCESS',
  FACE_REGISTRATION_CANCELLED = 'FACE_REGISTRATION_CANCELLED',
  FACE_REGISTRATION_SKIPPED = 'FACE_REGISTRATION_SKIPPED',
  FACE_REGISTRATION_ERROR = 'FACE_REGISTRATION_ERROR'
}

export interface FaceRegistrationEvent {
  type: FaceRegistrationEventType;
  temporaryPersonId?: string;
  message?: string;
  timestamp?: string;
}

// ===== RUTAS DE ACCESO =====
export enum AccessRoute {
  HOME = 'home',
  CREATE_INVITATION = 'create-invitation'
}
